export const uk = {
    all: 'Все',
    'find-platforms': 'Найти площадки',
    format: 'Формат',
    operator: 'Оператор',
    selected: 'Выбранные'
};
